var map = {
	"./press-releases.de-CH.json": 1578,
	"./press-releases.de-DE.json": 1579,
	"./press-releases.en-CA.json": 1580,
	"./press-releases.en-GB.json": 1581,
	"./press-releases.en-IN.json": 1582,
	"./press-releases.en-ME.json": 1583,
	"./press-releases.en-US.json": 1584,
	"./press-releases.es-EM.json": 1585,
	"./press-releases.es-ES.json": 1586,
	"./press-releases.fr-BE.json": 1587,
	"./press-releases.fr-CA.json": 1588,
	"./press-releases.fr-CH.json": 1589,
	"./press-releases.nl-BE.json": 1590,
	"./press-releases.nl-NL.json": 1591,
	"./press-releases.pl-PL.json": 1592,
	"./press-releases.pt-BR.json": 1593
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1577;